import React from 'react'
import { Input, Slider } from '@shopflo/ui'

export interface InputSliderProps {
  label: string
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  step?: number
  showDots?: boolean
  dotCount?: number
  unit?: string
  sliderWidth?: string
  labelClassName?: string
  labelTextClassName?: string
  trackClassName?: string
  rootClassName?: string
  controlsClassName?: string
}

export const InputSlider: React.FC<InputSliderProps> = ({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  showDots = true,
  dotCount = 5,
  unit = '',
  sliderWidth = 'w-[118px]',
  labelClassName = '',
  labelTextClassName = 'text-text-sm-medium text-zinc-600',
  trackClassName,
  rootClassName = '',
  controlsClassName = 'gap-2'
}) => {
  const handleSliderChange = (values: number[]) => {
    onChange(values[0])
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = Math.min(max, Math.max(min, parseInt(e.target.value) || min))
    onChange(Number(inputValue))
  }

  const handleInputFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    e.target.select()
  }

  return (
    <div className={`flex items-center justify-between ${rootClassName}`}>
      <span className={`${labelTextClassName} ${labelClassName}`}>{label}</span>
      <div className={`flex items-center ${controlsClassName}`}>
        <Slider
          value={[value]}
          onValueChange={handleSliderChange}
          min={min}
          max={max}
          step={step}
          showDots={showDots}
          dotCount={dotCount}
          className={sliderWidth}
          trackClassName={trackClassName}
        />

        {/* Value input */}
        <div className='w-12 flex items-center gap-1'>
          <Input
            endAdornment={unit ? <span className='text-xs px-1 text-zinc-400'>{unit}</span> : undefined}
            dimension='sm'
            variant='outline'
            type='number'
            min={min}
            max={max}
            value={Number(value)}
            onChange={handleInputChange}
            onFocus={handleInputFocus}
            className='w-full text-xs text-center px-0'
          />
        </div>
      </div>
    </div>
  )
}
